<template>
  <div>
    <h3>Active Matchmaking Positions: {{ positionsData.length }}</h3>

    <div class="filters">
      <span class="margin-right-unit">
        Show Expired Campaigns?
      </span>
      <el-radio-group v-model="showExpired">
        <el-radio-button :label="true">
          YES
        </el-radio-button>
        <el-radio-button :label="false">
          NO
        </el-radio-button>
      </el-radio-group>
    </div>

    <el-alert
      title="Expand row to view Campaign's Recruiter data"
      type="info"
      show-icon
    />

    <el-table
      border
      :data="positionsData"
      highlight-current-row
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <h5>Handler data (recruiter)</h5>
          <p><strong>Name:</strong> {{ props.row.first_name + ' ' + props.row.last_name }}</p>
          <p><strong>Email:</strong> {{ props.row.email }}</p>
          <p><strong>Account Status:</strong> {{ props.row.profile_status }}</p>
          <p><strong>Account Expire:</strong> {{ displayDate(props.row.profile_expiration_date) }}</p>
        </template>
      </el-table-column>

      <el-table-column
        prop="name"
        label="Campaign Name"
      />
      <el-table-column
        prop="description"
        label="Description"
      />
      <el-table-column
        prop="job_function"
        label="Job Function"
      >
        <template slot-scope="scope">
          {{ scope.row.job_function | NA | removeDashes | ucwords }}
        </template>
      </el-table-column>

      <el-table-column
        prop="created_date"
        label="Date Created"
      >
        <template slot-scope="scope">
          {{ displayDate(scope.row.created_date) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="expiration_date"
        label="Date Expiring"
      >
        <template slot-scope="scope">
          {{ displayDate(scope.row.expiration_date) }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  name: 'Matchmaking',
  data() {
    return {
      showExpired: false
    }
  },
  computed: {
    positionsData() {
      return this.$store.getters.matchmakingPositionData
    }
  },
  watch: {
    showExpired() {
      this.getMatchmakingPositions()
    }
  },
  async created() {
    await this.getMatchmakingPositions()
  },
  methods: {
    getMatchmakingPositions() {
      const params = {
        showExpired: this.showExpired
      }

      this.$store.dispatch('getMatchmakingPositions', { params })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~vars";

  .filters {
    text-align: right;
    padding: $-padding-unit 0;
  }
</style>
